import type { Key } from "react"
import { Modal } from "antd"

interface DeleteConfirmModalProps {
  deleteArray: Key[]
  loading: boolean
  open: boolean
  onCancel: () => void
  onOk: () => void
}

const DeleteConfirmModal = ({ deleteArray, loading, open, onCancel, onOk }: DeleteConfirmModalProps) => (
  <Modal
    title="Delete Item"
    open={open}
    centered
    onOk={onOk}
    onCancel={onCancel}
    okText="Yes"
    cancelText="No"
    confirmLoading={loading}
  >
    <div>
      {
        deleteArray.length > 1 ?
          'Are you sure you want to delete the selected items?'
          :
          'Are you sure you want to delete the selected item?'
      }
    </div>
  </Modal>
)

export default DeleteConfirmModal
